import React, { useEffect, useState } from 'react'
import { getNewsFeed } from '../../../services/dashboardServices'
import { Link } from 'react-router-dom'
import './index.scss'
import NewsCard from './NewsCard'
import { addError } from '../../../utils/analytics'
import { useTranslation } from 'react-i18next'
import envConfigs from '../../../configs/envConfigs'
import LoadingAnimation from '../../LoadingAnimation/LoadingAnimation' 

const NewsFeed = () => {
	const [articles, setArticles] = useState(null)
	const [alerts, setAlerts] = useState(null)
	const [isLoading, setIsLoading] = useState(true)
	const { t, i18n } = useTranslation(['labels', 'errors'])

	useEffect(() => {
		; (async () => {
			try {
				setIsLoading(true) 
				const response = await getNewsFeed()
				let alertsArray = [];
				let articlesArray = [];
				if (response && response.alerts && response.alerts.length > 0) {
					if (response.alerts.length >= 6) {
						alertsArray = response.alerts.splice(0, 6);
					}
					else {
						alertsArray = response.alerts;
					}
				}
				if (response && response.articles && response.articles.length > 0) {
					articlesArray = response.articles;

				}
				setArticles([...alertsArray].slice(0, 6))
				setArticles([...alertsArray.concat(...articlesArray)].slice(0, 6))
			} catch (error) {
				addError('NEWS_FEED_ERROR', error)
			} finally {
				setIsLoading(false) 
			}
		})()
	}, [])

	return (
		<div className='news-details-main-wrapper' id='news-details-main'>
			<div className='news-update-header-container'>
				<div className='news-update-subheading'>{t('EXTRAS.NEWS_AND_UPDATES')}</div>
				<a
					type="button"
					className="see-all-button d-none d-lg-flex"
					href={`${envConfigs.parentUrl}/${i18n.language}/news?eycache=34sdf`}
					target="_blank"
					rel="noopener noreferrer"
				>
					{t('DASHBOARD.SEE_ALL')}
				</a>
			</div>

		
			{isLoading ? (
				<LoadingAnimation />
			) : (
				articles && articles?.length > 0 && <NewsCard articles={articles} />
			)}
		</div>
	)
}
export default NewsFeed